import { tsGetScreenHoldingCollections } from '../../Typescript/API_Response'
import { useMessagePopupContext } from '../../garvan-react/Components/ModalFeedback/MessagePopup'
import { useQuery } from 'react-query'
import { AxiosResponse } from 'axios'
import { useUserContext } from '../../Contexts/UserConfig'
import ScreenHoldingService from '../PHP/APIs/ScreenHoldingService'

export function useGetScreenHoldingCollections(
  screen_holding_id: undefined | string,
) {
  const { whoAmI } = useUserContext()
  const { setError, setMessage } = useMessagePopupContext()
  return useQuery<tsGetScreenHoldingCollections | any, AxiosResponse>(
    ['ScreenHoldingService', 'getScreenHoldingCollections', screen_holding_id],
    () =>
      ScreenHoldingService.getScreenHoldingCollections(
        whoAmI!,
        screen_holding_id!,
      ),
    {
      enabled: !!whoAmI && !!screen_holding_id,
      onError: (err) => setError(err),
      onSuccess: (data) => {
        if (!data?.Collections) {
          setMessage({
            subject: 'Error getting screen holding collections',
            message: (data as any)?.message,
            severity: 'warning',
          })
        }
      },
    },
  )
}
